import {RPriceInfoModel} from './r-price-info.model';
import {ProductCategoryTypeEnum} from '../enums/product-category-type.enum';
import {TonerInfoModel} from './toner-info.model';
import {PagePricesModel} from './page-prices.model';
import {RPriceIdentifierEnum} from '../enums/r-price-identifier.enum';
import {EnumUtils} from '../utils/enum.utils';

export class ProductModel {

    id: number;
    category: string; // ProductCategoryTypeEnum;
    ean: string;
    sku: string;
    modelNumber: string;
    modelTitle: string;
    images: string[];
    printSmart: boolean;
    applicableToProducts: number[];

    visibleToChannelPartners: boolean;

    rPrices: RPriceInfoModel[];

    mpsSupplies: string[];
    pagePrices: PagePricesModel;
    tonerInfo: TonerInfoModel;

    hardwareColorTonerInfo: string; // HardwareTonerColorInfoEnum;

    brotherCustomProduct: boolean;


    /*
   * returns true if the product si any kind of device
    */
    public static isDevice(product: ProductModel): boolean {
        if (product && product.category) {
            const productCategoryEnum = ProductCategoryTypeEnum[product.category];
            return productCategoryEnum === ProductCategoryTypeEnum.PRINTER ||
                productCategoryEnum === ProductCategoryTypeEnum.MFC ||
                productCategoryEnum === ProductCategoryTypeEnum.SCANNER ||
                productCategoryEnum === ProductCategoryTypeEnum.LABELER ||
                productCategoryEnum === ProductCategoryTypeEnum.FAX ||
                productCategoryEnum === ProductCategoryTypeEnum.EOL ||
                productCategoryEnum === ProductCategoryTypeEnum.OTHER;
        }
        return false;
    }


    public static getColorPageRPrices(product: ProductModel): RPriceInfoModel[] {
        return [
            {
                rPriceIdentifier: EnumUtils.getKeyByValue(RPriceIdentifierEnum, RPriceIdentifierEnum.DEFAULT_PAGE_PRICE),
                rPrice: product && product.pagePrices && product.pagePrices.color
            } as RPriceInfoModel
        ];
    }

    public static getMonoPageRPrices(product: ProductModel): RPriceInfoModel[] {
        return [
            {
                rPriceIdentifier: EnumUtils.getKeyByValue(RPriceIdentifierEnum, RPriceIdentifierEnum.DEFAULT_PAGE_PRICE),
                rPrice: product && product.pagePrices && product.pagePrices.mono
            } as RPriceInfoModel
        ];
    }


    // filter out pagesRPrices and return RPrices for item itself
    // method should be removed, specification changed;
    public static getItemDedicatedRPrices(product: ProductModel): RPriceInfoModel[] {
        return product.rPrices;
    }

}

